import * as fonts from 'styles/base/font-faces.css'
import * as styles from 'styles/pages/Styleguide.css'
import * as cn from 'classnames'
import { Caption } from 'components/atoms/Text'

const Font = ({ text, style }: { text: string, style: string }) => (
  <div className={ cn(styles.typeface, style) }>
    <h5>
      ABCDEFGHIJKLMNOPQRSTUVWXYZ<br />
      abcdefghijklmnopqrstuvwxyz<br />
      1234567890<br />
      $¢£¥€&#§*†‡¶©®™@<br />
    </h5>
    <Caption text={ text } />
  </div>
)

const SGFonts = () => (
  <section className={ styles.sgSection }>
    <h2>Fonts</h2>
    <h4>sans-serif</h4>
    <Font text='graphik-bold' style={ fonts.sansBold } />
    <Font text='graphik-semibold' style={ fonts.sansSemibold } />
    <Font text='graphik-medium' style={ fonts.sansMedium } />
    <Font text='graphik-regular' style={ fonts.sansRegular } />
    <h4>serif</h4>
    <Font text='tiempos headline-medium' style={ fonts.serifMedium } />
    <Font text='tiempos text-regular' style={ fonts.serifRegular } />
    <Font text='tiempos headline-light' style={ fonts.serifLight } />
  </section>
)

export default SGFonts
